import apiClient from '../lib/axios';

export type IntegrationKey = 'DHIS2_SYNC' | 'SMS_SEND';

export interface IntegrationSetting {
  key: IntegrationKey;
  label: string;
  enabled: boolean;
  updatedAt: string;
  updatedBy: { id: string; firstName: string; lastName: string } | null;
}

export interface CountyEntry {
  county: string;
  enabled: boolean;
}

class IntegrationService {
  async getAll(): Promise<IntegrationSetting[]> {
    const response = await apiClient.get('/admin/integrations');
    return response.data.data;
  }

  async setEnabled(key: IntegrationKey, enabled: boolean): Promise<void> {
    await apiClient.patch(`/admin/integrations/${key}`, { enabled });
  }

  async getCounties(): Promise<CountyEntry[]> {
    const response = await apiClient.get('/admin/integrations/counties');
    return response.data.data;
  }

  async setCounties(counties: CountyEntry[]): Promise<void> {
    await apiClient.put('/admin/integrations/counties', { counties });
  }
}

export const integrationService = new IntegrationService();
